var tabsList = {

	oListForm:			'.tabsListForm',
	oListSection:		'.tabsListSection',
	oListFilter: 		'.tabsListFilter',
	oListSearch: 		'.tabsListSearch',
	oList:				'.tabsList',
	oListPager:			'.tabsListPager',
	oListNoResult:      '.tabsListNoResults',
	oListLoader:		'.tabsListLoader',
	//oListOpenFilters:	'.tabsListOpenFilters',
	//oListCloseFilters:	'.tabsListCloseFilters',
	//oListToggleFilter:	'.tabsListToggleFilter',
	oListViewSwitch:	'.tabsListViewSwitch',
	oListMap:			'.tabsListMap',
	oListResultCount:	'.tabsListResultCount',
	oListResultPageCurrent:	'.tabsListResultPageCurrent',
	oListResultPageTotal:	'.tabsListResultPageTotal',

	// Sortoptions
	oListLimit: 		'.tabsListLimit',
	oListSortorder:		'.tabsListSortorder',

	options: {

		scrollToTop: true,
		callbacks: {}

	},


	tools: {

		parseJSON: function(str) {

			try {

				return JSON.parse(str);

			}
			catch (e) {

				// console.err(e);
				// Return a default object, or null based on use case.
				return {}
			}
		}

	},

	/*
	 * ------------
	 * Init
	 * ------------
	 */

	init: function (options) {

		if (  typeof options !== 'undefined' ) {
			tabsList.options = Object.assign(tabsList.options, options);
		}

		let $sortOptions = {};
		
		$( document ).on( 'change', tabsList.oListSection + ' ' + tabsList.oListFilter, tabsList.bindFilter );
		$( document ).on( 'keyup', tabsList.oListSection + ' ' + tabsList.oListSearch, tabsList.bindSearch );

		$( document ).on( 'submit', tabsList.oListSection + ' ' + tabsList.oListForm, tabsList.bindForm );

		//$( document ).on( 'click', tabsList.oListSection + ' ' + tabsList.oListOpenFilters, tabsList.openFilters );
		//$( document ).on( 'click', tabsList.oListSection + ' ' + tabsList.oListCloseFilters, tabsList.refreshFilters );
		//$( document ).on( 'click', tabsList.oListSection + ' ' + tabsList.oListToggleFilter, tabsList.toggleFilter );

		//$( document ).on( 'keyup', tabsList.closeFilters );

		$( document ).on( 'click', tabsList.oListSection + ' ' + tabsList.oListPager + ' a', tabsList.bindPager );

		//$( document ).on( 'click.tabsFilterClose', 'body', tabsList.closeFilter );

		// Sortoptions

		$( document ).on( 'change', tabsList.oListSection + ' ' + tabsList.oListLimit, tabsList.bindSortoption );
		$( document ).on( 'change', tabsList.oListSection + ' ' + tabsList.oListSortorder, tabsList.bindSortoption );

		// Switch View

		$( document ).on( 'change', tabsList.oListViewSwitch, tabsList.bindViewSwitch );

		tabsList.initView();

		// Update sortoption toggle/label
		$sortOptions = $( tabsList.oListSortorder );

		tabsList.updateSelectedSortoption( $sortOptions );

		// tabsList.initFilter();


		//tabsList.initRangeFilters();

	},

	/*
	// initialize range filters
	initRangeFilters: function() {

		// @TODO: Make this work cleaner
		$( '.tabsListFilterRange' ).each( function() {

			var $thisRange = $(this);
			var $thisInput = $thisRange.find( '.tabsListFilterRangeHidden' );
			var $thisRangeInputs = $thisRange.find( '.tabsListFilterRangeInput' );

			console.log($thisRange);
			console.log($thisInput);
			console.log($thisRangeInputs);

			$( document ).off( 'change.updateRange' );
			$( document ).on( 'change.updateRange', $thisRangeInputs, function( e ) {

				// console.log( e );
				// console.log( $thisRangeInputs );
				// console.log( $thisRangeInputs.get() );
				// console.log( $thisRangeInputs.get(0) );
				// console.log( $thisRangeInputs.get(1) );
				// console.log( $(this) );
				// console.log( $(e) );

				var $firstInput = $($thisRangeInputs.get(0));
				var $secondInput = $($thisRangeInputs.get(1));

				var filterVal = '';
				var minVal = $firstInput.val().trim();
				var maxVal = $secondInput.val().trim();

				console.log( minVal + '-' + maxVal );

				if ( minVal.length > 0 && maxVal.length > 0 ) {

					filterVal = '<>||' + minVal + '-' + maxVal;

				} else if ( minVal.length > 0 && maxVal.length === 0 ) {

					filterVal = '>||' + minVal;

				} else if ( minVal.length === 0 && maxVal.length > 0 ) {

					filterVal = '<||' + maxVal;

				} else {

					filterVal = '';

				}

				$thisInput.val( filterVal );

				$thisInput.change();

				//console.log( filterVal );

			} );

		});

	},*/

	/*
	 * ------------
	 * Manual search form
	 * ------------
	 */

	/* // Not used
	submitManualFilterForm: function( e ) {

		e.preventDefault();

		let filterString = '';
		let $filters = $(this).find('select.tabsListFilter');
		let $search = $(this).find('input.filter_search');
		let searchUrl = $(this).attr('action');

		// Handle filters
		for ( let i=0; i<$filters.length; i++ ) {

			let $thisFilter = $filters[i];
			filterString += '&filter_' + i + '=["' + $thisFilter.value + '"]';

		}

		searchUrl += '?no=1' + filterString;

		// Handle search field
		if ( $search.length > 0 && typeof $search.get(0).value !== 'undefined') {

			let searchString = $search.get(0).value.trim();

			if (searchString.length > 0) {

				searchUrl += '&filter_search=' + encodeURIComponent(searchString);

			}

		}

		//console.log(searchUrl);

		window.location = searchUrl;

	},

	initFilter: function( e ) {

		let viewport = PROJECT.common.getViewport();

		if ( viewport.width > 996 ) {

			$( '.s-list__filter--open' ).css( 'transition-duration', '0ms' );
			$( '.s-list__filter--open' ).removeClass( 's-list__filter--open' );

		}

	},
	*/

	getSection: function( element ) {

		const section = $( element ).closest( tabsList.oListSection );

		return section;

	},

	getForm: function( element ) {

		const form = $( element ).closest( tabsList.oListForm );

		return form;

	},


	/*
	 * ------------
	 * Bind User Interaction
	 * ------------
	 */

	initView: function() {

		if ( $( tabsList.oListSection ).length > 0 && $( tabsList.oListMap ).length > 0 ) {

			tabsList.switchView( document.location.hash );

		}

	},

	bindViewSwitch: function( e ) {

		e.preventDefault();

		let checked = $( this ).prop('checked');
		let val ='';

		if ( checked ) {

			val = '#' + $( this ).val();

		} else {

			val = '#list';

		}

		tabsList.switchView( val );

	},

	switchView: function( viewHash ) {

		// Strip hash from location hash

		let view = viewHash.substr( 1 );

		if ( view === undefined || view === '' ) {

			view = 'list';

		}

		window.location.hash = view;

		// Set correct class

		if ( view === 'map' ) {

			$( tabsList.oListSection ).addClass( 's-list--map' );

			PROJECT.map.init();

		} else {

			$( tabsList.oListSection ).removeClass( 's-list--map' );

		}

		// Set current status for switch buttons

		if ( $( tabsList.oListViewSwitch ).val() === view ) {

			$( tabsList.oListViewSwitch ).prop( 'checked', true );

		} else {

			$( tabsList.oListViewSwitch ).prop( 'checked', false );

		}

	},

	/* openFilters: function( e ) {

		e.preventDefault();

		$( 'html' ).addClass( 'state-s-list--toggle-filters' );

	}, */

	/* closeFilters: function( e ) {

		if ( e.keyCode === 27 ) {

			tabsList.refreshFilters( e );

		}

	}, */

	/* toggleFilter: function( e ) {

		e.preventDefault();

		let isOpen = Boolean;
		let viewport = {};
		let $filterBox = {};

		tabsList.removeFilterFirst();

		isOpen = false;

		viewport = PROJECT.common.getViewport();

		$filterBox = $( this ).closest( '.s-list__filter' );

		if ( $filterBox.hasClass( 's-list__filter--open' ) ) {

			isOpen = true;

		}

		$( this ).closest( tabsList.oListForm ).find( '.s-list__filter--open' ).removeClass( 's-list__filter--open' );

		if ( !isOpen || viewport.width < 996 ) {

			$filterBox.addClass( 's-list__filter--open' );

		}

	}, */

	/* closeFilter: function( e ) {

		let $filterBox = {};

		$filterBox = $( '.tabsListCheckboxes' );

		if ( !$filterBox.is(e.target) && $filterBox.has(e.target).length === 0 ) {

			$( '.s-list__filter--open' ).removeClass( 's-list__filter--open' );

		}

		$( document ).off( 'click.closeListFilter', 'body' );

	}, */

	/* removeFilterFirst: function() {

		$( '.s-list__filter--first' ).removeClass( 's-list__filter--first' );

	}, */

	/* refreshFilters: function( e ) {

		e.preventDefault();

		$( '.s-list__filter--open' ).removeClass( 's-list__filter--open' );

	}, */

	bindFilter: function( e ) {

		e.preventDefault();

		const section = tabsList.getForm( this );

		let filterName = '';
		let $filterInput = {};
		let filterValue = '';
		let val = '';

		filterName = $( this ).attr( 'name' );

		$filterInput = $( 'input[name="' + filterName + '"]' );

		if ( $filterInput.length > 1 ) {

			filterValue = $( this ).val();

			// Unbind : otherwise the script will be triggered again

			$( document ).off( 'change', tabsList.oListFilter, tabsList.bindFilter );

			if ( filterValue === '' ) {

				// Uncheck all other when "All" is checked

				$( 'input[name="' + filterName + '"]' ). prop( 'checked', '' );
				$( this ). prop( 'checked', 'checked' );

			} else {

				// Uncheck "All" when another is checked

				$filterInput.each( function() {

					val = $( this ).val();

					if ( val === '' ) {

						$( this ). prop( 'checked', '' );

					}

				});

			}

			// Rebind

			$( document ).on( 'change', tabsList.oListFilter, tabsList.bindFilter );

		}

		//tabsList.refreshFilters( e );
		tabsList.getListItems( 1, section, 's-list--loading-renew' );

	},

	bindSortoption: function( e ) {

		e.preventDefault();

		const section = tabsList.getForm( this );

		tabsList.getListItems( 1, section );

		// Update sortoption toggle/label
		let $sortOptions = $( section ).find( tabsList.oListSortorder );

		tabsList.updateSelectedSortoption( $sortOptions );

	},

	updateSelectedSortoption: function( $sortOptions ) {

		// Let $sortOptions = $( section ).find( tabsList.oListSortorder );
		let $sortOptionContainer = $sortOptions.closest('.tabsListSortoptions');
		let $sortOptionToggle = $sortOptionContainer.find('.tabsListToggleSortoptions');

		let newText = $sortOptions.filter(':checked').data('label');

		$sortOptionToggle.text( newText );

	},

	bindSearch: function( e ) {

		e.preventDefault();

		window.clearTimeout( document.keywordTimeout );

		document.keywordTimeout = setTimeout(function () {

			$( tabsList.oListForm ).submit();

		}, 700 );

	},

	bindForm: function( e ) {

		e.preventDefault();

		const section = tabsList.getForm( this );

		tabsList.getListItems( 1, section );

	},

	bindPager: function( e ) {

		e.preventDefault();

		let $parent = $( this ).parent();

		if ( !$parent.hasClass( 'v-list-pager__page--disabled' ) ) {

			let pageNo = $( this ).data( 'paging' );
			
			const section = tabsList.getForm( this );

			tabsList.getListItems( pageNo, section );

		}

	},

	scrollToTop: function( $elm, offset ) {

		if ( typeof offset === 'undefined' ) {

			// Calculate offset based on vh
			var offsetVh = 25;
			var windowHeight = $(window).height();

			offset = ( windowHeight / 100 ) * offsetVh;

		}

		if ( typeof $elm !== 'undefined' && $elm.length > 0 ) {

			var scrollPosition = $elm.offset().top - offset;

			$('html, body').animate({ scrollTop: scrollPosition }, 600, 'linear' );

		}
		
	},

	/*
	 * ------------
	 * The List
	 * ------------
	 */

	getListItemsRunning: false,

	getListItems: function ( paging, form, classes ) {

		// this is the list form

		var $listForm = $( form );

		// loading class(es)

		var listLoadingClass = 's-list--loading';

		if ( typeof classes !== 'undefined' && classes != '' ) {

			listLoadingClass += ' ' + classes;

		}

		// get translastions array from form

		var listTranslations = $listForm.data( 'translations' );

		// get the list ID from a data attribute on the form

		var listID = $listForm.data( 'list' );

		// get the list config from the data form

		var listConfig = $listForm.attr( 'data-config' );

		// get the list source from a data attribute on the form

		var listSource = $listForm.data( 'source' );
		
		// Remove get params from source
		if (listSource.indexOf('?') > - 1) {

			listSource = listSource.substring(0, listSource.indexOf('?'));

		}

		// Remove protocol and domain from source
		listSource = listSource.replace( /^[a-zA-Z]{3,5}\:\/{2}[a-zA-Z0-9_.:-]+\//, '/' );

		// check if there is already a AJAX call running, if so; abort

		if ( tabsList.getListItemsRunning && tabsList.getListItemsRunning.readyState !== 4 ) {

			tabsList.getListItemsRunning.abort();

		}


		// get the form data and append vars needed in the backend
		
		let formData = new FormData( $listForm.get( 0 ) );
			formData.append( 'action', 'list_load' );
			formData.append( 'list', listID );
			formData.append( 'source', listSource );
			formData.append( listTranslations.paging, paging );

		if ( typeof listConfig !== 'undefined' && listConfig !== null ) {

			formData.append( 'config', listConfig );

		}

		// make a GET string of the form data

		let formDataString = new URLSearchParams( formData ).toString();

		// show loader

		$listForm.closest( tabsList.oListSection ).addClass( listLoadingClass );

		// Scroll to top, when needed
		let listConfigJson = tabsList.tools.parseJSON( listConfig );

		// do the ajax GET call

		tabsList.getListItemsRunning = $.ajax({

			url: ajax_object.ajaxurl,
			type: 'get',
			data: formDataString,

			success: function ( data ) {

				var scrollToTop = false;

				data = JSON.parse( data );

				tabsList.updateResultCount( data.posts_max );
				tabsList.updateResultPageCurrent( data.page_current );
				tabsList.updateResultPageTotal( data.pages_max );

				if ( data.config.pager.type == 'numbers' || paging == 1 ) {

					$listForm.find( tabsList.oList ).html( data.html );

				} else {

					$listForm.find( tabsList.oList ).append( data.html );

				}

				$listForm.find( tabsList.oListPager ).html( data.pager.html );

				// no results

				if( data.posts_max <= 0 ) {
					
					$listForm.find( tabsList.oListNoResult ).css('display','block');

				}else {

					$listForm.find( tabsList.oListNoResult ).css('display','none');

				}


				// hide loader

				$listForm.closest( tabsList.oListSection ).removeClass( listLoadingClass);

				// Push url

				let push_url 	= data.url;
				let push_obj	= { rand: Math.random() };

				if ( push_url !== '' ) {

					history.pushState( push_obj, '', push_url );

				}

				if ( tabsList.options.scrollToTop === true ) {

					if ( ( typeof listConfigJson !== 'undefined' && typeof listConfigJson.pager !== 'undefined' && typeof listConfigJson.pager.type !== 'undefined' && listConfigJson.pager.type === 'numbers') || paging === 1 ) {

						tabsList.scrollToTop( $listForm.find( tabsList.oList ) );

					}

				}

				if (("afterAjaxCallback" in tabsList.options.callbacks)) {

					if( typeof tabsList.options.callbacks.afterAjaxCallback == "function" ){

						tabsList.options.callbacks.afterAjaxCallback( data );

					}

				}

			},
			
			cache: true,
			contentType: false,
			processData: false,

		});

		/* $( section ).closest( '.s-list' ).addClass( 's-list--loading' );

		let config = {

			ID					:	$( section ).data( 'page' ),
			ID_section			:	$( section ).data( 'section' ),
			cf_list_template	:	$( section ).data( 'template' ),

			_user_filters		:	filters,
			_user_search		:	search,
			_user_page			:	pageNo

		}; */

		// // Not used $( section ).find( tabsList.oList ).slideUp( 300 );

		/* // Sortorder options
		let $limitOptions = $( section ).find( tabsList.oListLimit );
		let $sortOptions = $( section ).find( tabsList.oListSortorder );

		if ( $limitOptions.length > 0 && $limitOptions.val() !== '' ) {

			config._user_posts_per_page = $limitOptions.val();

		}

		if ( $sortOptions.length > 0 && $sortOptions.filter(':checked').val() !== '' ) {

			config._user_sortorder = $sortOptions.filter(':checked').val();

		}

		tabsList.getListItemsRunning = $.get( ajax_object.ajaxurl, {

			action	:	'list_load',
			config	:	config

		}, function( data ) {

			data = JSON.parse( data );

			tabsList.updateListFilters( data.filters );

			$( section ).find( tabsList.oList ).html( data.html );
			// Not used $( section ).find( tabsList.oList ).slideDown( 300 );

			$( section ).find( tabsList.oListPager ).html( data.pager_html );

			// Set map

			if ( $( section ).find( tabsList.oListMap + ' .gMap' ).length ) {

				let mapElement = $( section ).find( tabsList.oListMap + ' .gMap' );
					mapElement = mapElement.get( 0 );
					mapElement.dataset.pins = JSON.stringify( data.maps );

			}

			PROJECT.map.maps();

			// Push url

			let push_url 	= data.url;
			let push_obj	= { rand: Math.random() };

			if ( push_url !== '' ) {

				history.pushState( push_obj, '', push_url );

			}

			setTimeout( function() {

				$( section ).closest( '.s-list' ).removeClass( 's-list--loading' );

			}, 500 );

		}); */

	},

	updateResultCount: function( count ) {

		$( tabsList.oListResultCount ).text( count );

	},

	updateResultPageCurrent: function( count ) {

		$( tabsList.oListResultPageCurrent ).text( count );

	},

	updateResultPageTotal: function( count ) {

		$( tabsList.oListResultPageTotal ).text( count );

	},

	updateListPager: function( no ) {

	},

	updateListFilters: function( filters ) {

		// Reset all filters to 0 and set disable class

		let $parent = {};
		let $filter = {};
		let $filterCount = {};

		$( tabsList.oListFilter ).each( function( e ) {

			$parent = $( this ).closest( '.a-list-filter-checkbox' );
			$filterCount = $parent.find( '[data-filter]' );

			if ( $filterCount.length >= 1 ) {

				$parent.addClass( 'a-list-filter-checkbox--disabled' );

				$filterCount.text( '(0)' );

			}

		});

		// Update filter count if filter term has value and remove disable class

		Object.keys( filters ).forEach( function( filter_key ) {

			$filter = $( '[data-filter="' + filter_key + '"]' );
			$parent = $filter.closest( '.a-list-filter-checkbox' );

			$filter.text( '(' + filters[filter_key] + ')' );
			$parent.removeClass( 'a-list-filter-checkbox--disabled' );

		});

	}
	
};

window.tabsList = tabsList; // Webpack fix
